// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"BookInput__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BookInput/BookInput.scss
 ** module id = 890
 ** module chunks = 1
 **/